import TextFieldValidation from '@components/TextFieldValidation/TextFieldValidation';
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	Typography
} from '@mui/material';
import { useFormik } from 'formik';
import { noop } from 'lodash';
import React from 'react';
import { AccessKeyType } from 'types/accessKeys';

interface IAccessKeyCopyDialogProps {
	onComplete: () => void;
	generatedKey: string;
	translationPrefix: `${AccessKeyType}`;
}

const AccessKeyCopyDialog: React.FC<IAccessKeyCopyDialogProps> = ({
	onComplete,
	generatedKey,
	translationPrefix
}) => {
	const formik = useFormik({
		initialValues: {
			generatedKey
		},
		onSubmit: noop
	});

	return (
		<Dialog open maxWidth="sm" data-testid="access-key-copy-dialog">
			<DialogTitle>
				{intl.tr(`${translationPrefix}.action.copy.dialog.title`)}
			</DialogTitle>
			<DialogContent>
				<Box pb={1}>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Typography variant="body1" whiteSpace="break-spaces">
								{intl.tr('accessKeys.action.copy.dialog.body1')}
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body1" whiteSpace="break-spaces">
								{intl.tr(`${translationPrefix}.action.copy.dialog.body2`)}
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<TextFieldValidation
								id="generatedKey"
								formik={formik}
								copy
								label={intl.tr('accessKeys.action.copy.dialog.label')}
								disabled
								fullWidth
								value={generatedKey}
							/>
						</Grid>
					</Grid>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" color="primary" onClick={onComplete}>
					{intl.tr('accessKeys.action.copy.dialog.done')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AccessKeyCopyDialog;
